import { render } from "./BienvenidaPage.vue?vue&type=template&id=73084076&scoped=true"
import script from "./BienvenidaPage.vue?vue&type=script&lang=js"
export * from "./BienvenidaPage.vue?vue&type=script&lang=js"

import "./BienvenidaPage.vue?vue&type=style&index=0&id=73084076&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73084076"]])

export default __exports__